export default {
    namespaced: true,
    state: {
        data: {},
        error: false,
        loading: false,
        validationErrors: {},
    },
    mutations: {
        setData: (state, data) => (state.data = { ...data }),
        setError: (state, error) => (state.error = error),
        setValidationErrors: (state, errors) => (state.validationErrors = errors),
        removeError: state => (state.error = false),
        loadingProcess: state => (state.loading = true),
        loadingCompleted: state => (state.loading = false),
    },
    actions: {
        fetchOperator: ({commit}, id) => {
            commit("loadingProcess");
            return axios.get(`/admin/operator/${id}`)
                .then(res => {
                    commit("setData", res.data.data)
                    commit('removeError')
                    commit("setValidationErrors", {})
                })
                .catch(err => {
                    commit("setError", err.message ?? "Неизвестная ошибка");
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"))
        },
        update: ({commit, state}, data) => {
            commit("loadingProcess");
            return axios.put(`/admin/operator/${state.data.id}`, data)
                .then( res =>  {
                    commit("setData", res.data.data)
                    commit("setValidationErrors", {})
                    commit('removeError')
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? err.message ?? "Неизвестная ошибка");
                    commit("setValidationErrors", err.response.data.errors ?? {})
                    console.error(err);
                })
                .finally(() => commit("loadingCompleted"))
        },
        setData: ({commit}, data) => {
            commit('setData', data)
        }
    }
};
